
import {QCheckbox, QEditor, QPagination, QScrollArea, QSpinner, QTab, QTabs, QToggle, Ripple} from 'quasar'
import {DataManager} from '@parantion/components'
import {convertToISO_8601_String} from '../../../utils/date-utils'

export default {
  name: 'distribution',
  directives: {
    Ripple
  },
  components: {
    QSpinner,
    QCheckbox,
    QPagination,
    QToggle,
    Ripple,
    QScrollArea,
    QTabs,
    QTab,
    QEditor,
    DataManager
  },
  props: {
    title: ''
  },
  filters: {
    dateFilter: value => value ? convertToISO_8601_String(value, 'dd-MM-yyyy') : '',
  },
  computed: {
    data () {
      return [].concat(this.$store.state.survey.surveyData.data).sort((a, b) => a['sur_serial'] - b['sur_serial'])
    },
    filter () {
      return (this.$store.state.survey.surveyData).fields
    }
  },
  data () {
    return {
      isLoading: false,
      isInitialLoading: true
    }
  },
  methods: {
    /**************************************
     * Modal window functions
     **************************************/
    show () {
      this.$refs.modal.show()
      this.refreshData()
    },
    hide () {
      this.$refs.modal.hide()
    },

    async refreshData () {
      this.isLoading = true
      this.isInitialLoading = true
      await this.$store.dispatch('survey/getSurveyData')
      this.isInitialLoading = false
      this.isLoading = false
    },

    async deleteSelection (selection) {
      this.isLoading = true
      await this.$store.dispatch('respondent/deleteRespondents', selection)
      this.refreshData()
    }
  }
}
